import { useEffect, useState } from 'react';
import { getAllAuditModules, watchAudit, watchAuditsForOrg, watchAuditExports } from '@/lib/firestore';
import type { AuditDoc, ExportDoc } from '@/types/models';
import type { DocumentData } from 'firebase/firestore';

export function useAudits(orgId: string | null, opts: { limit?: number } = {}) {
  const [audits, setAudits] = useState<AuditDoc[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!orgId) { setAudits([]); setLoading(false); return; }
    setLoading(true);
    return watchAuditsForOrg(orgId, list => { setAudits(list); setLoading(false); }, opts);
  }, [orgId, opts.limit]);
  return { audits, loading };
}

export function useAudit(auditId: string | undefined) {
  const [audit, setAudit] = useState<AuditDoc | null>(null);
  const [modules, setModules] = useState<Record<string, DocumentData>>({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!auditId) { setAudit(null); setLoading(false); return; }
    setLoading(true);
    return watchAudit(auditId, async a => {
      setAudit(a);
      if (a?.status === 'ready') {
        setModules(await getAllAuditModules(auditId));
      }
      setLoading(false);
    });
  }, [auditId]);
  return { audit, modules, loading };
}

export function useAuditExports(auditId: string | undefined) {
  const [exports_, setExports] = useState<ExportDoc[]>([]);
  useEffect(() => {
    if (!auditId) return;
    return watchAuditExports(auditId, setExports);
  }, [auditId]);
  return exports_;
}
